<template>
  <div class="deviceShadow">
    <div class="topTitle">
      <img :src="require('../../../../assets/device_icon_title_grey.svg')" class="titleSvg" />
      <span class="titleRecipeName">{{ $t('Device.await') }}</span>
    </div>
    <div class="centerIcon">
      <img :src="require('../../../../assets/device_pic_standby.svg')" class="cookingIcon" />
    </div>
    <div class="statusName">
      {{ $t(`Device.await`) }}
    </div>
  </div>
</template>

<script>
import { format, formatTime, formatNumWithComma } from '@/utils/utils'
import { DeviceCurrStepType } from '@/config/status'
export default {
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    format,
    formatTime,
    formatNumWithComma
  },
  data() {
    return {
      DeviceCurrStepType
    }
  }
}
</script>

<style scoped lang="scss">
.deviceShadow {
  width: 332px;
  height: 208px;
  border-radius: 16px;
  border: 1px solid #dcdfe6;
  padding: 16px;
  .topTitle {
    display: flex;
    align-items: center;
    .titleSvg {
      height: 14px;
      width: 14px;
      margin-right: 8px;
      line-height: 22px;
    }
    .titleMid {
      margin-right: 8px;
      font-size: 12px;
      height: 14px;
      font-weight: 400;
      color: #333333;
    }
    .titleRecipeName {
      font-size: 14px;
      font-weight: 600;
      color: #333333;
    }
  }
  .centerIcon {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 8px auto 8px auto;
    .cookingIcon {
      width: 84px;
      height: 84px;
    }
  }
  .statusName {
    text-align: center;
    color: #333333;
    line-height: 22px;
  }
}
</style>
